export const environment = {
  production: false,
  apiBaseUrl: 'https://dynamic-api.ambitiousdesert-ff05010c.westeurope.azurecontainerapps.io'
};
